import { createContext } from '@chakra-ui/react-utils'

const [ListGroupProvider, useListGroupContext] = createContext({
  name: 'ListGroupContext',
  errorMessage:
    'useListGroupContext: `context` is undefined. Seems you forgot to wrap the components in `<ListGroup />`'
})

export const useListGroup = ({ isMovable = false, isSelectable = false }) => {
  const getListGroupItemProps = () => {
    return {
      isMovable,
      isSelectable
    }
  }

  return {
    getListGroupItemProps
  }
}

export const useListGroupItem = props => {
  const { getListGroupItemProps } = useListGroupContext()
  const { isMovable, isSelectable } = getListGroupItemProps()

  return {
    isMovable,
    isSelectable
  }
}

export { ListGroupProvider, useListGroupContext }
